import LeadershipList from "./LeadershipList";

const BoardOfDirectors = ({
}) => {
    return <LeadershipList type="board_of_directors"/>;
}
export default BoardOfDirectors;